export const GoogleIcon = () => (
    <img className="custom-google-icon" src={require('../../google_icon.png')} height="18" alt="SVG as an image" />
);

export const MicrosoftIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="7" height="7" fill="#F25022" />
        <rect x="10" y="1" width="7" height="7" fill="#7FBA00" />
        <rect x="1" y="10" width="7" height="7" fill="#00A4EF" />
        <rect x="10" y="10" width="7" height="7" fill="#FFB900" />
    </svg>
);